module.exports = __webpack_public_path__ + "img/standard.9866ba38.png";